import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import {
  getPostLoadMetaRequest,
  getUserSettingsRequest,
  getUserSubscriptionMetadataRequest,
} from '../../../../../home/extra-actions';
import {
  resetSubscription,
  resetPurchaseInboxAnalyzerSubscriptionRequestStatus,
  resetPurchaseInboxAnalyzerModifySubscriptionResponse,
} from '../../billing-subscription-slice';
import {
  calculateInboxAnalyzerPayRequest,
  getInboxAnalyzerSubscriptionRequest,
  paddlePollingThunk,
  purchaseInboxAnalyzerModifySubscriptionRequest,
  purchaseInboxAnalyzerSubscriptionRequest,
} from '../../extra-actions';
import {
  CalculatePayRequest,
  PurchaseModifySubscriptionRequest,
  PurchaseSubscriptionRequest,
} from '../../types';
import { PaddleApplicationType } from '../../types/paddle';
import InboxRadarPlans from './inbox-radar-plans';
import { selectPaddleCustomerId } from '../../../../../home/home-slice';

const mapStateToProps = (state: RootState) => ({
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetInboxAnalyzerSubscriptionRequestStatus:
    state.billingAndSubscription.getInboxAnalyzerSubscriptionRequest.status,
  sendGetInboxAnalyzerSubscriptionResponse:
    state.billingAndSubscription.getInboxAnalyzerSubscriptionResponse,
  sendGetInboxAnalyzerPlansResponse:
    state.billingAndSubscription.getInboxAnalyzerPlansResponse,
  sendPurchaseInboxAnalyzerSubscriptionRequestStatus:
    state.billingAndSubscription?.purchaseInboxAnalyzerSubscriptionRequest
      .status,
  sendPurchaseInboxAnalyzerSubscriptionRequestMessage:
    state.billingAndSubscription.purchaseInboxAnalyzerSubscriptionRequest
      .message,
  sendGetPurchaseInboxAnalyzerModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseInboxAnalyzerModifySubscriptionRequest
      .status,
  sendPurchaseInboxAnalyzerModifySubscriptionResponse:
    state.billingAndSubscription
      .purchaseInboxAnalyzerModifySubscriptionResponse,
  sendGetCalculateInboxAnalyzerPayRequestStatus:
    state.billingAndSubscription.calculateInboxAnalyzerPayRequest.status,

  couponCodeDiscount:
    state.billingAndSubscription.applyCouponCodeResponse?.discountValue,
  couponCodeDiscountType:
    state.billingAndSubscription.applyCouponCodeResponse?.discountType,
  paymentProvider: state.home?.paymentProvider,
  userId: state.home?.userId,
  shAccountId: state.home?.shAccountId,
  userEmail: state.home?.email,
  adminSettings: state.adminSettings.adminSettings,
  paddlePolling: state.billingAndSubscription.paddlePolling,
  paddleCustomerId: selectPaddleCustomerId(state),
});

const mapDispatchToProps = {
  sendGetCalculateInboxAnalyzerPayRequest: (payload: CalculatePayRequest) =>
    calculateInboxAnalyzerPayRequest(payload),
  sendPurchaseInboxAnalyzerSubscriptionRequest: (
    payload: PurchaseSubscriptionRequest,
  ) => purchaseInboxAnalyzerSubscriptionRequest(payload),
  sendPurchaseInboxAnalyzerModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseInboxAnalyzerModifySubscriptionRequest(payload),
  sendGetInboxAnalyzerSubscriptionRequest: () =>
    getInboxAnalyzerSubscriptionRequest(),
  sendGetUserSettingsRequest: () => getUserSettingsRequest(),
  sendGetUserSubscriptionMetadataRequest: () =>
    getUserSubscriptionMetadataRequest(),
  resetSubscription: () => resetSubscription(),
  startPaddlePollingThunk: (payload: {
    shAccountId: number;
    applicationType: PaddleApplicationType;
    planId?: number;
  }) => paddlePollingThunk(payload),
  resetPurchaseInboxAnalyzerSubscriptionRequestStatus: () =>
    resetPurchaseInboxAnalyzerSubscriptionRequestStatus(),
  resetPurchaseInboxAnalyzerModifySubscriptionResponse: () =>
    resetPurchaseInboxAnalyzerModifySubscriptionResponse(),
  sendGetPostLoadMetaRequest: () => getPostLoadMetaRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(InboxRadarPlans);
